angular.module('elogbooksDirectives').directive('note', function () {
    return {
        restrict: 'AE',
        templateUrl: '/modules/directives/note/note.html',
        scope: {
            note: '=ngModel'
        }
    }
});
